<script setup lang="ts">
import { computed } from 'vue'
import { useLocale } from '@/composables/useLocale'

const { t } = useLocale()
const currentYear = computed(() => new Date().getFullYear())
</script>

<template>
  <footer class="footer">
    <div class="footer-wrapper">
      <div class="footer-content">
        <div class="footer-text">
          <p>— I have a strange feeling. What's it? Even now…</p>
          <p>— I AM LA CONCEPTUALITÉ, I AM THE CAPITAL.</p>
          <p>
            I AM A PIECE OF THE WORLD SPIRIT, THE PATRONESS OF THE FLUTTER OF DUST ON YOUR CLOTHES,
            THE OBSESSIVE CHILL OF LOWER ART. «MY HEART IS A WARMING DRAFT. MY AIR IS CREEPING RED,
            I HAVE HUNDREDS OF THOUSANDS OF GLOWING HANDS. THE MODULATIONS OF MY VOICE ARE
            REGISTERED BY THERMOMETERS AND BAROMETERS. YOU BREATHE ME IN WITH YOUR NOSTRILS, YOU
            FEEL ME WITH THE HAIRS ON THE BACK OF YOUR NECK.» WE ARE EACH OTHER. — DISCO ELYSIUM
          </p>
        </div>
        <div class="footer-links">
          <nav class="footer-nav">
            <span>VY™ ©{{ currentYear }} {{ t('footer.allRightsReserved') }}</span>
            <router-link :to="{ name: 'Membership' }">{{ t('footer.becomeMember') }}</router-link>
            <router-link :to="{ name: 'Terms' }">{{ t('footer.termsConditions') }}</router-link>
            <router-link :to="{ name: 'Shipping' }">{{ t('footer.shippingReturns') }}</router-link>
            <router-link :to="{ name: 'Cookie' }">{{ t('footer.cookiePolicy') }}</router-link>
          </nav>
        </div>
      </div>
      <div class="footer-placeholder">
        <img src="@/assets/graphics/logo2.svg" alt="VY Logo" />
      </div>
    </div>
  </footer>
</template>


<style scoped>
.footer {
  width: 100%;
  background-color: white;
  padding: 40px 20px;
  text-align: center;
  flex-shrink: 0;
}

.footer-wrapper {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 40px;
}

.footer-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer-text {
  margin-bottom: 40px;
  font-size: 16px;
  line-height: 1.6;
  color: black;
  text-align: center;
  max-width: 920px;
  font-family: 'Wremena', serif;
}

.footer-text p {
  margin-bottom: 16px;
}

.footer-text p:last-child {
  margin-bottom: 0;
}

.footer-links {
  width: 100%;
}

.footer-placeholder {
  flex-shrink: 0;
}

.footer-placeholder img {
  width: 100px;
  height: 100px;
  object-fit: contain;
}

.footer-nav {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  font-size: 14px;
  font-weight: bold;
  color: black;
  text-transform: uppercase;
  font-family: 'Roboto Mono', serif;
  background-color: #d9d9d9;
  padding: 1px 6px;
  height: 20px;
  align-items: center;
}

.footer-nav a {
  color: inherit;
  text-decoration: none;
  transition: opacity 0.2s ease;
}

.footer-nav a:hover {
  opacity: 0.7;
}

.footer-nav span {
  cursor: pointer;
}

@media (max-width: 1024px) {
  .footer-nav {
    flex-wrap: wrap;
    justify-content: center;
    text-align: center;
    gap: 16px 24px;
    height: auto;
    padding: 8px 16px;
  }
}

@media (max-width: 768px) {
  .footer {
    padding: 20px 16px;
  }

  .footer-wrapper {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
    gap: 20px;
  }

  .footer-content {
    display: contents;
  }

  .footer-text {
    width: 100%;
    font-size: 18px;
    line-height: 0.9;
    text-align: left;
    margin-bottom: 0;
    font-family: 'Wremena', serif;
    letter-spacing: -0.72px;
    font-feature-settings: 'lnum' 1, 'pnum' 1;
    grid-column: 1;
    grid-row: 1;
  }

  .footer-text p {
    margin-bottom: 0;
  }

  .footer-links {
    width: auto;
    grid-column: 1;
    grid-row: 2;
    justify-self: flex-start;
  }

  .footer-nav {
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
    height: auto;
    padding: 0;
    background: none;
  }

  .footer-nav span,
  .footer-nav a {
    background-color: #d9d9d9;
    padding: 1px 6px;
    display: inline-block;
    font-size: 14px;
  }

  .footer-placeholder {
    grid-column: 1;
    grid-row: 2;
    justify-self: flex-end;
    margin-top: 0;
  }

  .footer-placeholder img {
    width: 94px;
    height: 102px;
  }
}
</style>
